const baseRoute = "/login";

export const loginAPIRoute = (route) => {
  return `${baseRoute}${route}`;
};
